import type { Compromisso } from '../db/tipos'
import { agoraISO, novoRegistroBase } from '../db/tipos'
import { apagarLocalEEnfileirar, gravarLocalEEnfileirar } from '../sync/outbox'
import { validarCompromisso, type RascunhoCompromisso } from './regras'

// Editar parte do existente (id, criado_em, situacao): o servidor faz upsert
// na mesma linha em vez de criar outra.
export async function salvarCompromisso(r: RascunhoCompromisso, existente?: Compromisso): Promise<string> {
  const erro = validarCompromisso(r)
  if (erro) throw new Error(erro)
  const registro: Compromisso = {
    ...(existente ?? { ...novoRegistroBase(), situacao: 'pendente' as const }),
    data: r.data,
    hora: r.hora.slice(0, 5),
    assunto: r.assunto.trim(),
    cliente_id: r.cliente_id,
    aviso_minutos: r.aviso_minutos,
    atualizado_em: agoraISO(),
  }
  await gravarLocalEEnfileirar('compromissos', registro)
  return registro.id
}

export async function alternarSituacao(c: Compromisso): Promise<void> {
  await gravarLocalEEnfileirar('compromissos', {
    ...c,
    situacao: c.situacao === 'pendente' ? 'feito' : 'pendente',
    atualizado_em: agoraISO(),
  })
}

export async function excluirCompromisso(id: string): Promise<void> {
  await apagarLocalEEnfileirar('compromissos', id)
}
